import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Typography, Button, Divider, ButtonGroup, Grid } from '@mui/material';

import {
    viewSelector, changeView, getFuelSetup, finalizeSetup,
    deleteSetup,
} from '../../features/fueladmin/fuelSlice';
import { useridSelector } from '../../features/user/UserSlice';
import { deleteSensor } from '../../features/fueladmin/fuelSlice';

const FuelLeftColumn = ({ fuelSetup, assetId, assetData }) => {
    const dispatch = useDispatch();
    const view = useSelector(viewSelector);
    const userid = useSelector(useridSelector);

    const addSensor = (n) => {
        dispatch(changeView({ view: 'addSensor', sensorIndex: n }));
    }
    const sensorCalibrate = (n) => {
        dispatch(changeView({ view: 'calibrateSensor', sensorIndex: n }));
    }


    const addTank = (n) => {
        dispatch(changeView({ view: 'addTank', tankIndex: n }));
    }
    const editTank = (n) => {
        dispatch(changeView({ view: 'editTank', tankIndex: n }));
    }
    const mapSensor = (n) => {
        dispatch(changeView({ view: 'mapSensor', tankIndex: n }));
    }

    const addEvent = () => {
        dispatch(changeView({ view: 'addEvent' }));
    }
    const editEvent = () => {
        dispatch(changeView({ view: 'editEvent' }));
    }

    const changeDevice = () => {
        dispatch(changeView({ view: 'changeDevice' }));
    }

    return (
        <div>
            {
                view === 'nodata' ?
                    <Typography variant="h6">No Setup Found</Typography>
                    : view === 'basicDetails' ?
                        <Typography variant="body1">Initiate the setup by entering these basic details about the vehicle and its tank and sensor setup.</Typography>
                        : fuelSetup &&
                        <div>
                                <Typography varinat="body1"><b>Type</b>: {fuelSetup.vehicleType}</Typography>
                                <Typography varinat="body1"><b>Make</b>: {fuelSetup.make}</Typography>
                                <Typography varinat="body1"><b>Model</b>: {fuelSetup.model}</Typography>

                            <Divider />
                            <br />
                            {
                                    fuelSetup.sensors && fuelSetup.sensors.length > 0 && fuelSetup.sensors.map((a, i) =>
                                    <div key={i}>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            spacing={1}
                                        >
                                            <Grid item xs={4}>
                                                <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'black' }}>Sensor {i + 1}</span> </Button>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <ButtonGroup variant="text" aria-label="text button group">
                                                    {a.sensorId ?
                                                        null
                                                        :
                                                        <Button size="small" onClick={() => addSensor(i + 1)}>Add</Button>
                                                    }

                                                    {
                                                        a.sensorId ? a.calibrationCode ?
                                                            <Button size="small" onClick={() => sensorCalibrate(i + 1)}>Recalibrate</Button>
                                                            :
                                                            <Button size="small" onClick={() => sensorCalibrate(i + 1)}>Calibrate</Button>
                                                            : null
                                                    }
                                                    {
                                                        a.sensorId && a.sensorIndex &&
                                                        <Button size="small" onClick={() => dispatch(deleteSensor({ assetId, userid, sensorIndex: a.sensorIndex }))}><span style={{ color: 'red' }}>Delete</span> </Button>
                                                    }
                                                </ButtonGroup>
                                            </Grid>
                                        </Grid>


                                    </div>
                                )
                            }
                            <br />
                            <Divider />
                            <br />
                            <div>
                                {
                                        fuelSetup.tanks && fuelSetup.tanks.length > 0 && fuelSetup.tanks.map((a, i) =>
                                        <div key={i}>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                spacing={1}
                                            >
                                                <Grid item xs={4}>
                                                    <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'black' }}>Tank {i + 1}</span> </Button>

                                                </Grid>
                                                <Grid item xs={8}>
                                                    <ButtonGroup variant="text" aria-label="text button group">
                                                        {a.tankId ?
                                                            <Button size="small" onClick={() => editTank(i + 1)}>Edit</Button>
                                                            :
                                                            <Button size="small" onClick={() => addTank(i + 1)}>Add</Button>
                                                        }

                                                        {
                                                            a.tankId ?
                                                                <Button size="small" onClick={() => mapSensor(i + 1)}>Map Sensors</Button>
                                                                : null
                                                        }
                                                    </ButtonGroup>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )
                                }
                            </div>
                            <br />
                            <Divider />
                            <div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item xs={4}>
                                        <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'black' }}>Events</span> </Button>

                                    </Grid>
                                    <Grid item xs={8}>
                                        <ButtonGroup variant="text" aria-label="text button group">
                                            {fuelSetup.event && fuelSetup.event.eventId ?
                                                <Button size="small" onClick={() => editEvent()}>Edit</Button>
                                                :
                                                <Button size="small" onClick={() => addEvent()}>Create</Button>
                                            }
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </div>

                            <Divider />

                            <div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item xs={4}>
                                        <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'black' }}>Finalize</span> </Button>

                                    </Grid>
                                    <Grid item xs={8}>
                                        <ButtonGroup variant="text" aria-label="text button group">
                                            <Button size="small" onClick={() => dispatch(getFuelSetup({ assetId, userid }))}>Verify</Button>
                                            {
                                                fuelSetup && (!fuelSetup.error || fuelSetup.error.length === 0 || !fuelSetup.success) &&
                                                <Button size="small" onClick={() => dispatch(finalizeSetup({ assetId, userid }))}>Commit</Button>
                                            }
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </div>
                            <Divider />

                            <div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item xs={4}>
                                        <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'red' }}>Device</span> </Button>

                                    </Grid>
                                    <Grid item xs={8}>
                                        <ButtonGroup variant="text" aria-label="text button group">
                                            <Button size="small" onClick={() => changeDevice()}>Change</Button>
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </div>
                            <Divider />

                            <div>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={1}
                                >
                                    <Grid item xs={4}>
                                        <Button size="small" disabled style={{ justifyContent: "flex-start" }}><span style={{ color: 'red' }}>Setup</span> </Button>

                                    </Grid>
                                    <Grid item xs={8}>
                                        <ButtonGroup variant="text" aria-label="text button group">
                                            <Button size="small" onClick={() => dispatch(deleteSetup({ assetId, userid }))}>Delete</Button>


                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </div>


                        </div>
            }

        </div>
    )
}

export default FuelLeftColumn